import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import { RiCloseFill } from '@remixicon/react'
import * as React from 'react'
import { COLORS } from '../../common/colors'

interface BootstrapDialogTitleProps {
  id: string
  classes?: string
  children?: React.ReactNode
  onClose?: () => void
  fontSize?: string
}

export const BootstrapDialogTitle = (props: BootstrapDialogTitleProps) => {
  const { children, onClose, fontSize, classes, ...other } = props

  return (
    <DialogTitle classes={{ root: classes }} sx={{ m: 0, p: 2, fontSize: fontSize || '1.25rem' }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label='close'
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <RiCloseFill color={COLORS.text} />
        </IconButton>
      ) : null}
    </DialogTitle>
  )
}
